import PropTypes from 'prop-types';
import cn from 'classnames';

export default function ImageColumn({
  imgObjectFit = 'cover',
  columnSize = 'col-12 col-md-6',
  caption = '',
  children,
  link,
  className,
  ...rest
}) {
  const ImgWrapper = () => {
    if (link) {
      return (
        <a {...link}>
          {children}
        </a>
      );
    }

    return <>{children}</>;
  };

  return (
    <div
      className={cn(
        'lds-half-billboard-img',
        columnSize,
        className
      )}
      {...rest}
    >
      <div
        className={cn(
          'lds-half-billboard-img-container',
          `${imgObjectFit}`,
          {
            'has-caption': caption,
          }
        )}
        style={{ backgroundSize: imgObjectFit, backgroundPosition: 'center center' }}
      >
        <ImgWrapper />
        {caption && <p className="h3">{caption}</p>}
      </div>
    </div>
  );
}

ImageColumn.propTypes = {
  imgObjectFit: PropTypes.oneOf(['cover', 'contain']),
  link: PropTypes.shape({ href: PropTypes.string, target: PropTypes.string }),
};
